export default __webpack_public_path__ + "static/media/1784.fb8ff96f.png";